import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export {
  CloseButton,
  Overlay,
  SheetHeader,
  SheetPanel,
  SheetTitle,
} from "../sheet.style";

export const TravellerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  overflow-y: auto;
`;

export const TravellerRow = styled.p`
  margin: 0;
  font-size: ${fontSize.font16};
  color: ${theme.blackText};
`;

export const TravellerName = styled.span`
  font-weight: ${fontWeight.bold};
`;

export const TravellerMeta = styled.span`
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
`;
